/* eslint-disable @atlaskit/design-system/use-primitives-text */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@compiled/react';

import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	button: {
		display: 'flex',
		alignItems: 'center',
		// NO ADS token exists for 18px (space.200 = 16px, space.250 = 20px)
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		gap: '18px',
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#1F1F21',
		border: 'none',
		borderRadius: token('radius.large'),
		paddingInline: token('space.200'),
		paddingBlock: token('space.200'),
		cursor: 'pointer',
		textAlign: 'left',
		'&:focus-visible': {
			outline: `2px solid ${token('color.border.focused')}`,
			outlineOffset: token('space.025'),
		},
	},
	iconContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		width: '32px',
		height: '32px',
		borderRadius: token('radius.large'),
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#303134',
	},
	label: {
		flex: '1 0 0',
		minWidth: 0,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#B7B9BE',
		font: token('font.body.large'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		lineHeight: '28px',
		margin: 0,
	},
});

type ShowMoreButtonProps = {
	expanded: boolean;
	onClick: () => void;
	children: ReactNode;
};

export const ShowMoreButton = ({
	expanded,
	onClick,
	children,
}: ShowMoreButtonProps): JSX.Element => {
	return (
		<button css={styles.button} type="button" onClick={onClick} aria-expanded={expanded}>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<span css={styles.iconContainer}>
				{expanded ? (
					<ChevronUpIcon label="" color="currentColor" />
				) : (
					<ChevronDownIcon label="" color="currentColor" />
				)}
			</span>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p css={styles.label}>{children}</p>
		</button>
	);
};
